import Vue from "vue";
import Router from "vue-router";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/error/401",
    component: () => import("@/views/error/401"),
    hidden: true
  },
  {
    path: "/error/404",
    component: () => import("@/views/error/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    name: "",
    // hidden: true,
    children: [
      {
        path: "/",
        name: "Dashboard",
        meta: { title: "首页", icon: "dashboard", affix: true },
        component: () => import("@/views/dashboard/index")
      }
    ]
  },
  {
    path: "",
    component: Layout,
    name: "Info",
    hidden: true,
    children: [
      {
        path: "/info",
        component: () => import("@/views/info/index")
      }
    ]
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  }
];

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: "history",
  routes: constantRouterMap
});

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "User",
    meta: { title: "用户管理", permissions: ["admin"], icon: "users" },
    children: [
      {
        path: "/user/list",
        name: "Users",
        component: () => import("@/views/user/index"),
        meta: { title: "用户列表", permissions: ["admin"] }
      },
      {
        path: "/user/subordinate",
        name: "subordinate",
        hidden:true,
        component: () => import("@/views/user/subordinate"),
        meta: { title: "下级列表", permissions: ["admin"] }
      },
      {
        path: "/user/SignList",
        name: "SignList",
        component: () => import("@/views/user/SignList"),
        meta: { title: "签到记录", permissions: ["admin"] }
      },
      
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "energy",
    meta: { title: "定价管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/energy/index",
        name: "energyIndex",
        component: () => import("@/views/energy/index"),
        meta: { title: "能量包管理", permissions: ["admin"] }
      },
      
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Course",
    meta: { title: "课程管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/course/type/index",
        name: "courseTypeIndex",
        component: () => import("@/views/course/typeIndex"),
        meta: { title: "课程系列", permissions: ["admin"] }
      },
      {
        path: "/course/Teacher/index",
        name: "courseTeacherIndex",
        component: () => import("@/views/course/teacherIndex"),
        meta: { title: "讲师管理", permissions: ["admin"] }
      },

      {
        path: "/course/index",
        name: "courseIndex",
        component: () => import("@/views/course/index"),
        meta: { title: "课程管理", permissions: ["admin"] }
      },
      
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "chat",
    meta: { title: "问答管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/chat/index",
        name: "chatIndex",
        component: () => import("@/views/chat/index"),
        meta: { title: "问答记录", permissions: ["admin"] }
      },
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "creativeSpace",
    meta: { title: "绘画管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/creativeSpace/index",
        name: "creativeSpace",
        component: () => import("@/views/creativeSpace/index"),
        meta: { title: "绘画记录", permissions: ["admin"] }
      },
      
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "aiMarkdown",
    meta: { title: "ai文档管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/aiMarkdown/index",
        name: "aiMarkdown",
        component: () => import("@/views/aiMarkdown/index"),
        meta: { title: "生成记录", permissions: ["admin"] }
      },
      
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "news",
    meta: { title: "运营管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/banner/index",
        name: "bannerIndex",
        component: () => import("@/views/banner/index"),
        meta: { title: "轮播图", permissions: ["admin"] }
      },
      {
        path: "/news/index",
        name: "newsIndex",
        component: () => import("@/views/news/index"),
        meta: { title: "资讯列表", permissions: ["admin"] }
      },
      
    ]
  },
  
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Finance",
    meta: { title: "财务管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/finance/list",
        name: "FinanceList",
        component: () => import("@/views/finance/index"),
        meta: { title: "财务统计", permissions: ["admin"] }
      },
      {
        path: "/member/list",
        name: "memberList",
        component: () => import("@/views/member/list"),
        meta: { title: "会员购买记录", permissions: ["admin"] }
      },
      {
        path: "/finance/agent_index",
        name: "agentList",
        component: () => import("@/views/finance/agent_index"),
        meta: { title: "会员奖励列表", permissions: ["admin"] }
      },
      {
        path: "/finance/energy_agent_index",
        name: "energy_agent_index",
        component: () => import("@/views/finance/energy_agent_index"),
        meta: { title: "能量包奖励列表", permissions: ["admin"] }
      },
      {
        path: "/finance/energy_index",
        name: "energyList",
        component: () => import("@/views/finance/energy_index"),
        meta: { title: "能量包订单列表", permissions: ["admin"] }
      }
    ]
  },
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "MemberCard",
    meta: { title: "会员卡管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/memberCard/indexTask",
        name: "MemberCardTask",
        component: () => import("@/views/memberCard/indexTask"),
        meta: { title: "新增记录", permissions: ["admin"] }
      },

      {
        path: "/memberCard/inedx",
        name: "MemberCard",
        component: () => import("@/views/memberCard/index"),
        meta: { title: "会员卡列表", permissions: ["admin"] }
      },
      
      
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "cashOut",
    meta: { title: "提现管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/cashOut/inedx",
        name: "cashOutIndex",
        component: () => import("@/views/cashOut/index"),
        meta: { title: "提现列表", permissions: ["admin"] }
      },
      
      
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "goods",
    meta: { title: "教育商品管理", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/goods/inedx",
        name: "goodsIndex",
        component: () => import("@/views/goods/index"),
        meta: { title: "商品列表", permissions: ["admin"] }
      },
      
      
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "System",
    meta: { title: "系统设置", permissions: ["admin"], icon: "system" },
    children: [
      {
        path: "/system/config",
        name: "Config",
        component: () => import("@/views/system/config"),
        meta: { title: "参数设置", permissions: ["admin"] }
      },
      {
        path: "/system/configEnglishChat",
        name: "configEnglishChat",
        component: () => import("@/views/system/configEnglishChat"),
        meta: { title: "Ai教育", permissions: ["admin"] }
      },
      {
        path: "/system/setText",
        name: "setText",
        component: () => import("@/views/system/setText"),
        meta: { title: " 协议设置", permissions: ["admin"] }
      }, 
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Admin",
    meta: { title: "管理员设置", permissions: ["admin", "role"], icon: "system" },
    children: [
      {
        path: "/admin/list",
        name: "Admin",
        component: () => import("@/views/admin/index"),
        meta: { title: "管理员列表", permissions: ["admin"] }
      },
      // {
      //   path: "/roles",
      //   name: "Role",
      //   component: () => import("@/views/role/index"),
      //   meta: { title: "角色列表", permissions: ["role"] }
      // }
    ]
  },

  // {
  //   path: "",
  //   component: Layout,
  //   alwaysShow: true,
  //   name: "Others",
  //   meta: { title: "其他", icon: "others" },
  //   children: [
  //     {
  //       path: "/map",
  //       name: "Map",
  //       component: () => import("@/views/others/map"),
  //       meta: { title: "地图" }
  //     }
  //   ]
  // },
  { path: "*", redirect: "/error/404", hidden: true }
];
